import * as React from "react";
import { ui } from "../../../../dependencies";
const FavoritesIcon = props => React.createElement("div", { className: `rj-ev-list__fav-icon`, onClick: props.favoritesHandler, "data-uat": `ev-list-fav-icon` },
    React.createElement(ui.Icon, { i: `i-12 i-o-fav i-o-fav-row ${props.isInFavorites ? "i-o-fav-selected" : ""}` }));
FavoritesIcon.displayName = "FavoritesIcon";
export default React.memo(FavoritesIcon);
//# sourceMappingURL=FavoritesIcon.js.map